import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=283744ab&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=js&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports